import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type ReauthDialogState = {
    returnUrl?: string;
    message?: string;
};

@Injectable({ providedIn: 'root' })
export class ReauthDialogService {
    private readonly stateSubject = new BehaviorSubject<ReauthDialogState | null>(null);
    readonly state$ = this.stateSubject.asObservable();

    isOpen(): boolean {
        return Boolean(this.stateSubject.value);
    }

    open(state: ReauthDialogState = {}): void {
        if (this.isOpen()) return;
        this.stateSubject.next({
            returnUrl: state.returnUrl,
            message: state.message
        });
    }

    close(): void {
        this.stateSubject.next(null);
    }
}

